// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Card */
.card {
    margin-bottom: 30px;
    border: none;
    border-radius: 5px;
    box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
  }
  
  .card-header,
  .card-footer {
    border-color: #ebeef4;
    background-color: #fff;
    color: #798eb3;
    padding: 15px;
  }
  
  .user-webnexs .card-title {
    padding: 20px 0 15px 0;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    font-family: "Poppins", sans-serif;
  }

  .user-webnexs span.small.pt-1.fw-bold {
    color: black;
}
  
  .card-title span {
    color: #899bbd;
    font-size: 14px;
    font-weight: 400;
  }
  
  .card-body {
    padding: 0 20px 20px 20px;
  }
  
  .card-img-overlay {
    background-color: rgba(255, 255, 255, 0.6);
  }
  
  .dashboard .nav-link{
    border-radius: 5px;
    border-bottom: 1px solid #e9e6e6;
    font-weight: 500;
    color: #000000;
    background-color: #e1e1e1;
  }

  .dashboard .nav-link.active {
    background: rgb(255 255 255 / 20%);
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

  .upload-video {background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;}

  .iq-card {
    background: #fff;
    border-radius: 5px;
    margin-bottom: 30px;
    border: none;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
    border-radius: 5px;}

    
    .react-calendar {
      width: 100%;
      max-width: 100%;
      background: white;
      border: 1px solid #a0a096;
      font-family: Arial, Helvetica, sans-serif;
      line-height: 1.125em;
    }
    .react-calendar--doubleView {
      width: 700px;
    }
    .react-calendar--doubleView .react-calendar__viewContainer {
      display: flex;
      margin: -0.5em;
    }
    .react-calendar--doubleView .react-calendar__viewContainer > * {
      width: 50%;
      margin: 0.5em;
    }
    .react-calendar,
    .react-calendar *,
    .react-calendar *:before,
    .react-calendar *:after {
      box-sizing: border-box;
    }
    .react-calendar button {
      margin: 0;
      border: 0;
      outline: none;
    }
    .react-calendar button:enabled:hover {
      cursor: pointer;
    }
    .react-calendar__navigation {
      display: flex;
      height: 44px;
      margin-bottom: 1em;
    }
    .react-calendar__navigation button {
      min-width: 44px;
      background: none;
    }
    .react-calendar__navigation button:disabled {
      background-color: #f0f0f0;
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: #e6e6e6;
    }
    .react-calendar__month-view__weekdays {
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 0.75em;
    }
    .react-calendar__month-view__weekdays__weekday {
      padding: 0.5em;
    }
    .react-calendar__month-view__weekNumbers .react-calendar__tile {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75em;
      font-weight: bold;
    }
    .react-calendar__month-view__days__day--weekend {
      color: #d10000;
    }
    .react-calendar__month-view__days__day--neighboringMonth {
      color: #757575;
    }
    .react-calendar__year-view .react-calendar__tile,
    .react-calendar__decade-view .react-calendar__tile,
    .react-calendar__century-view .react-calendar__tile {
      padding: 2em 0.5em;
    }
    .react-calendar__tile {
      max-width: 100%;
      padding: 20px .6667px;
      background: none;
      text-align: center;
      line-height: 16px;
    }
    .react-calendar__tile:disabled {
      background-color: #f0f0f0;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
      background-color: #e6e6e6;
    }
    .react-calendar__tile--now {
      background: #ffff76;
    }
    .react-calendar__tile--now:enabled:hover,
    .react-calendar__tile--now:enabled:focus {
      background: #ffffa9;
    }
    .react-calendar__tile--hasActive {
      background: #76baff;
    }
    .react-calendar__tile--hasActive:enabled:hover,
    .react-calendar__tile--hasActive:enabled:focus {
      background: #a9d4ff;
    }
    .react-calendar__tile--active {
      background: #006edc;
      color: white;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
      background: #1087ff;
    }
    .react-calendar--selectRange .react-calendar__tile--hover {
      background-color: #e6e6e6;
    }
    `, "",{"version":3,"sources":["webpack://./src/Pages/Ads_Categories/Ads_Campaigns/AdsCampaigns.css"],"names":[],"mappings":";AACA,SAAS;AACT;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;EACpC;;EAEA;IACE,YAAY;AAChB;;EAEE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;EAEE,eAAe,yBAAyB;EACxC,aAAa;EACb,mBAAmB,CAAC;;EAEpB;IACE,gBAAgB;IAGhB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB,CAAC;;;IAGnB;MACE,WAAW;MACX,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,yCAAyC;MACzC,oBAAoB;IACtB;IACA;MACE,YAAY;IACd;IACA;MACE,aAAa;MACb,cAAc;IAChB;IACA;MACE,UAAU;MACV,aAAa;IACf;IACA;;;;MAME,sBAAsB;IACxB;IACA;MACE,SAAS;MACT,SAAS;MACT,aAAa;IACf;IACA;MACE,eAAe;IACjB;IACA;MACE,aAAa;MACb,YAAY;MACZ,kBAAkB;IACpB;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;IACA;MACE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;MACE,kBAAkB;MAClB,yBAAyB;MACzB,iBAAiB;MACjB,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,iBAAiB;MACjB,iBAAiB;IACnB;IACA;MACE,cAAc;IAChB;IACA;MACE,cAAc;IAChB;IACA;;;MAGE,kBAAkB;IACpB;IACA;MACE,eAAe;MACf,qBAAqB;MACrB,gBAAgB;MAChB,kBAAkB;MAClB,iBAAiB;IACnB;IACA;MACE,yBAAyB;IAC3B;IACA;;MAEE,yBAAyB;IAC3B;IACA;MACE,mBAAmB;IACrB;IACA;;MAEE,mBAAmB;IACrB;IACA;MACE,mBAAmB;IACrB;IACA;;MAEE,mBAAmB;IACrB;IACA;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;;MAEE,mBAAmB;IACrB;IACA;MACE,yBAAyB;IAC3B","sourcesContent":["\n/* Card */\n.card {\n    margin-bottom: 30px;\n    border: none;\n    border-radius: 5px;\n    box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n  }\n  \n  .card-header,\n  .card-footer {\n    border-color: #ebeef4;\n    background-color: #fff;\n    color: #798eb3;\n    padding: 15px;\n  }\n  \n  .user-webnexs .card-title {\n    padding: 20px 0 15px 0;\n    font-size: 18px;\n    font-weight: 500;\n    color: #000000;\n    font-family: \"Poppins\", sans-serif;\n  }\n\n  .user-webnexs span.small.pt-1.fw-bold {\n    color: black;\n}\n  \n  .card-title span {\n    color: #899bbd;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  \n  .card-body {\n    padding: 0 20px 20px 20px;\n  }\n  \n  .card-img-overlay {\n    background-color: rgba(255, 255, 255, 0.6);\n  }\n  \n  .dashboard .nav-link{\n    border-radius: 5px;\n    border-bottom: 1px solid #e9e6e6;\n    font-weight: 500;\n    color: #000000;\n    background-color: #e1e1e1;\n  }\n\n  .dashboard .nav-link.active {\n    background: rgb(255 255 255 / 20%);\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n}\n\n  .upload-video {background-color: #fafafa;\n  padding: 10px;\n  border-radius: 10px;}\n\n  .iq-card {\n    background: #fff;\n    -webkit-border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n    margin-bottom: 30px;\n    border: none;\n    box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\n    border-radius: 5px;}\n\n    \n    .react-calendar {\n      width: 100%;\n      max-width: 100%;\n      background: white;\n      border: 1px solid #a0a096;\n      font-family: Arial, Helvetica, sans-serif;\n      line-height: 1.125em;\n    }\n    .react-calendar--doubleView {\n      width: 700px;\n    }\n    .react-calendar--doubleView .react-calendar__viewContainer {\n      display: flex;\n      margin: -0.5em;\n    }\n    .react-calendar--doubleView .react-calendar__viewContainer > * {\n      width: 50%;\n      margin: 0.5em;\n    }\n    .react-calendar,\n    .react-calendar *,\n    .react-calendar *:before,\n    .react-calendar *:after {\n      -moz-box-sizing: border-box;\n      -webkit-box-sizing: border-box;\n      box-sizing: border-box;\n    }\n    .react-calendar button {\n      margin: 0;\n      border: 0;\n      outline: none;\n    }\n    .react-calendar button:enabled:hover {\n      cursor: pointer;\n    }\n    .react-calendar__navigation {\n      display: flex;\n      height: 44px;\n      margin-bottom: 1em;\n    }\n    .react-calendar__navigation button {\n      min-width: 44px;\n      background: none;\n    }\n    .react-calendar__navigation button:disabled {\n      background-color: #f0f0f0;\n    }\n    .react-calendar__navigation button:enabled:hover,\n    .react-calendar__navigation button:enabled:focus {\n      background-color: #e6e6e6;\n    }\n    .react-calendar__month-view__weekdays {\n      text-align: center;\n      text-transform: uppercase;\n      font-weight: bold;\n      font-size: 0.75em;\n    }\n    .react-calendar__month-view__weekdays__weekday {\n      padding: 0.5em;\n    }\n    .react-calendar__month-view__weekNumbers .react-calendar__tile {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 0.75em;\n      font-weight: bold;\n    }\n    .react-calendar__month-view__days__day--weekend {\n      color: #d10000;\n    }\n    .react-calendar__month-view__days__day--neighboringMonth {\n      color: #757575;\n    }\n    .react-calendar__year-view .react-calendar__tile,\n    .react-calendar__decade-view .react-calendar__tile,\n    .react-calendar__century-view .react-calendar__tile {\n      padding: 2em 0.5em;\n    }\n    .react-calendar__tile {\n      max-width: 100%;\n      padding: 20px .6667px;\n      background: none;\n      text-align: center;\n      line-height: 16px;\n    }\n    .react-calendar__tile:disabled {\n      background-color: #f0f0f0;\n    }\n    .react-calendar__tile:enabled:hover,\n    .react-calendar__tile:enabled:focus {\n      background-color: #e6e6e6;\n    }\n    .react-calendar__tile--now {\n      background: #ffff76;\n    }\n    .react-calendar__tile--now:enabled:hover,\n    .react-calendar__tile--now:enabled:focus {\n      background: #ffffa9;\n    }\n    .react-calendar__tile--hasActive {\n      background: #76baff;\n    }\n    .react-calendar__tile--hasActive:enabled:hover,\n    .react-calendar__tile--hasActive:enabled:focus {\n      background: #a9d4ff;\n    }\n    .react-calendar__tile--active {\n      background: #006edc;\n      color: white;\n    }\n    .react-calendar__tile--active:enabled:hover,\n    .react-calendar__tile--active:enabled:focus {\n      background: #1087ff;\n    }\n    .react-calendar--selectRange .react-calendar__tile--hover {\n      background-color: #e6e6e6;\n    }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
